import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs, { Dayjs } from "dayjs";

interface CancellationFiltersState {
  bookingDateFrom: Dayjs | null;
  startRange: Dayjs | null;
  endRange: Dayjs | null;
  memberShipType: string;
  categoryId: string;
  bookingStatus: string;
  subcategoryId: string;
  numberofGuest: string;
  employeeId: string[];
  userId: string[];
  isTodayBooking: boolean;
  bookingNumberofDays: boolean;
}

const initialState: CancellationFiltersState = {
  bookingDateFrom: null,
  startRange: null,
  endRange: null,
  memberShipType: "",
  categoryId: "",
  bookingStatus: "",
  subcategoryId: "",
  numberofGuest: "",
  employeeId: [],
  userId: [],
  isTodayBooking: false,
  bookingNumberofDays: false,
};

// Load from localStorage if exists
const savedFilters = localStorage.getItem("cancellationFilters");
const persistedState = savedFilters
  ? {
      ...initialState,
      ...JSON.parse(savedFilters),
      // Convert ISO strings back to Dayjs
      startRange: JSON.parse(savedFilters)?.startRange
        ? dayjs(JSON.parse(savedFilters)?.startRange)
        : null,
      endRange: JSON.parse(savedFilters)?.endRange
        ? dayjs(JSON.parse(savedFilters)?.endRange)
        : null,
      bookingDateFrom: JSON.parse(savedFilters)?.bookingDateFrom
        ? dayjs(JSON.parse(savedFilters)?.bookingDateFrom)
        : null,
    }
  : initialState;

const cancellationFiltersSlice = createSlice({
  name: "cancellationFilters",
  initialState: persistedState,
  reducers: {
    setCancellationFilters(
      state,
      action: PayloadAction<Partial<CancellationFiltersState>>
    ) {
      Object.assign(state, action.payload);
      localStorage.setItem("cancellationFilters", JSON.stringify(state));
    },
    resetCancellationFilters() {
      localStorage.removeItem("cancellationFilters");
      return initialState;
    },
  },
});

export const { setCancellationFilters, resetCancellationFilters } =
  cancellationFiltersSlice.actions;

export default cancellationFiltersSlice.reducer;
